import { Component, Input } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { environment } from 'src/environments/environment';
import { Brand } from 'src/app/domain/models/funnel/brand-enum';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';

@Component({
  selector: 'app-header-1087',
  templateUrl: './header-1087.component.html',
  styleUrls: ['./header-1087.component.scss']
})
export class Header1087Component {
  @Input() brandResources!: IBrandResources;
  @Input() FunnelFlow!: FunnelFlow;
  public pathLogoBrand: string = '';
  public brandNumber: string = '';
  public environment = environment;

  ngOnInit(): void {
      this.pathLogoBrand = this.environment.assetsURL + this.brandResources.pathLogoLandingPage;
      this.brandNumber = this.brandResources.brandNumber!;
  }
}